import { formatPLN } from "@/lib/api";

export default function BudgetCard({ monthly, used, remaining, pendingValue = 0, title = "Budżet miesięczny" }) {
  const pct = monthly > 0 ? (used / monthly) * 100 : 0;
  const pctWithPending = monthly > 0 ? ((used + pendingValue) / monthly) * 100 : 0;
  const clamped = Math.min(Math.max(pctWithPending, 0), 100);

  let color = "bg-emerald-500";
  let label = "W normie";
  if (pctWithPending >= 100) {
    color = "bg-red-500";
    label = "Przekroczono";
  } else if (pctWithPending >= 80) {
    color = "bg-amber-500";
    label = "Bliskie limitu";
  }

  return (
    <div className="ol-kpi" data-testid="budget-card">
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{title}</p>
          <p className="mt-1 text-3xl font-bold tracking-tight text-slate-900">{formatPLN(monthly)}</p>
        </div>
        <span className={`ol-badge ${pct >= 80 ? (pct >= 100 ? "bg-red-50 text-red-700" : "bg-amber-50 text-amber-700") : "bg-emerald-50 text-emerald-700"}`}>
          {label}
        </span>
      </div>

      <div className="w-full h-3 rounded-full bg-slate-100 overflow-hidden" data-testid="budget-progress">
        <div
          className={`h-full ${color} transition-all`}
          style={{ width: `${clamped}%` }}
        />
      </div>
      <div className="mt-3 grid grid-cols-3 gap-4 text-sm">
        <div>
          <p className="text-xs text-slate-500">Wykorzystano</p>
          <p className="font-semibold text-slate-900" data-testid="budget-used">{formatPLN(used)}</p>
        </div>
        <div>
          <p className="text-xs text-slate-500">Pozostało</p>
          <p className={`font-semibold ${remaining < 0 ? "text-red-600" : "text-slate-900"}`} data-testid="budget-remaining">{formatPLN(remaining)}</p>
        </div>
        <div>
          <p className="text-xs text-slate-500">Wykorzystanie</p>
          <p className="font-semibold text-slate-900">{pct.toFixed(1)}%</p>
        </div>
      </div>

      {pendingValue > 0 && (
        <div className="mt-3 text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded-md px-3 py-2" data-testid="budget-pending">
          Wartość bieżącego zamówienia: <span className="font-semibold text-slate-900">{formatPLN(pendingValue)}</span>{" "}
          – pozostałoby <span className={`font-semibold ${remaining - pendingValue < 0 ? "text-red-600" : "text-slate-900"}`}>{formatPLN(remaining - pendingValue)}</span>
        </div>
      )}
    </div>
  );
}
